export type MonitoringState = 'active' | 'paused' | 'stopped' | 'not_started';

export interface MonitoringStateMeta {
    label: string;
    dotClass: string;
    textClass: string;
    /** Warning tag for trigger cells; absent while monitoring runs. */
    tag?: { label: string; className: string; tooltip: string };
}

// DM's enum (unstarted | started | paused | stopped) is mirrored capitalised; Monday writes
// "Resumed" for an active monitoring, so it folds into active like the rest of the app does.
export function monitoringStateOf(raw: string | null): MonitoringState {
    const status = (raw ?? '').toLowerCase();
    if (status === 'started' || status === 'resumed') return 'active';
    if (status === 'paused') return 'paused';
    if (status === 'stopped') return 'stopped';
    return 'not_started';
}

const FROZEN_COUNT = 'so the aligner count is not moving';

// Same tones as the work-queue monitoring ring and the patient overview's Monitoring card.
export const MONITORING_STATE_META: Record<MonitoringState, MonitoringStateMeta> = {
    active: {
        label: 'Monitoring active',
        dotClass: 'bg-emerald-500',
        textClass: 'text-emerald-700'
    },
    paused: {
        label: 'Monitoring paused',
        dotClass: 'bg-amber-500',
        textClass: 'text-amber-700',
        tag: {
            label: 'Paused',
            className: 'border-amber-200 bg-amber-50 text-amber-700',
            tooltip: `Monitoring is paused, ${FROZEN_COUNT}`
        }
    },
    stopped: {
        label: 'Monitoring stopped',
        dotClass: 'bg-red-500',
        textClass: 'text-red-700',
        tag: {
            label: 'Stopped',
            className: 'border-red-200 bg-red-50 text-red-700',
            tooltip: `Monitoring is stopped, ${FROZEN_COUNT}`
        }
    },
    not_started: {
        label: 'Not monitored',
        dotClass: 'bg-gray-300',
        textClass: 'text-gray-500',
        tag: {
            label: 'Not monitored',
            className: 'border-gray-200 bg-gray-50 text-gray-600',
            tooltip: `Monitoring has not started, ${FROZEN_COUNT}`
        }
    }
};
